var common = require("../../utiles/common");
function viewModelWx(params) {
  var $this = this;

  $this.openCode = function () {
    var state = sessionStorage.getItem("state")
      ? sessionStorage.getItem("state")
      : "";
    var data = common.fetch(params.baseUrl + params.url, {
      type: "GET",
      query: { state: state },
    });
    if (window.WxLogin) {
      window.WxLogin({
        id: "wx-qrcode-container",
        href: "",
        scope: "snsapi_login",
        state: data.state,
        response_type: "code",
        appid: data.appid,
        redirect_uri:
          data.redirect_uri +
          "?" +
          encodeURIComponent(window.location.href.split("?")[1]),
      });
    }
  };
  setTimeout(function () {
    $this.openCode();
  }, 200);
}
// 组件销毁时循环函数设置为undefined
viewModelWx.prototype.dispose = function () {
  this.qrLoop = undefined;
};

module.exports = {
  register: function () {
    document.createElement("wx-login");
    ko.components.register("wx-login", {
      viewModel: viewModelWx,
      template: require("./Wx.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/weixin/Wx.js
// module id = 113
// module chunks = 0